export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-file-paper-line',
      color: 'bg-blue-400',
      title: 'Media & Drukwerk',
      description: 'Folders, flyers, visitekaartjes en posters van topkwaliteit',
    },
    {
      icon: 'ri-printer-line',
      color: 'bg-teal-400',
      title: '3D Printen',
      description: 'Innovatieve 3D printoplossingen voor al uw projecten',
    },
    {
      icon: 'ri-scan-line',
      color: 'bg-red-400',
      title: 'Digitalisering',
      description: 'Uw documenten digitaal bewaren en beheren',
    },
    {
      icon: 'ri-briefcase-line',
      color: 'bg-purple-400',
      title: 'Relatiegeschenken',
      description: 'Zakelijke geschenken die indruk maken',
    },
  ];

  return (
    <section className="py-16 bg-white/10 backdrop-blur-xs">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-linear-to-r from-white/20 to-white/10 rounded-xl p-8 border border-white/30">
            <h3 className="text-3xl font-bold text-white mb-4">
              Wat kunt u verwachten?
            </h3>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
              {services.map((service, index) => (
                <div key={index} className="text-center">
                  <div
                    className={`w-16 h-16 ${service.color} rounded-full flex items-center justify-center mx-auto mb-4`}
                  >
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                  <h4 className="text-xl font-semibold text-white mb-2">
                    {service.title}
                  </h4>
                  <p className="text-white/90 text-sm">{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
